import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { useAppAccountSearchOrganisationsList } from '@shared/api/lib/app/app';
import {
  AppAccountSearchOrganisationsListParams,
  PaginatedOrganisationSummaryList,
} from '@shared/api/types';

/** Shortest query worth sending. The endpoint itself answers from 2. */
export const ORGANISATION_SEARCH_MIN_LENGTH = 3;

/**
 * Search organisations to switch into. Staff only — a 403 for everyone else.
 *
 * Disabled below the minimum query length so no request is made while the
 * switcher is sitting empty.
 */
export const useGetOrganisationSearch = (
  params?: AppAccountSearchOrganisationsListParams
) =>
  useAppAccountSearchOrganisationsList<PaginatedOrganisationSummaryList>(
    params,
    {
      request: useAxiosConfig(),
      query: {
        enabled:
          (params?.search?.length ?? 0) >= ORGANISATION_SEARCH_MIN_LENGTH,
        keepPreviousData: true,
      },
    }
  );
